import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class UtilsService {
  getNameFromData(data: string): string {
    try {
      const parsedData = JSON.parse(data);
      return parsedData?.name || '';
    } catch (e) {
      return '';
    }
  }
}
